import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const TitleWrapper = styled.section`
  display: flex;
  width: 100%;
  ${bp('sm')`
    flex-wrap: wrap;
    margin-bottom: 40px;
    justify-content: center;
  `}
`

export const DropDown = styled.select`
  height: 42px;
  padding: 0 10px;
`

export const DateField = styled.span`
  width: 84px;
  text-align: center;
  padding-right: 2px;
`

export const Row = styled.li`
  span,
  label {
    flex-grow: 1;
    width: 33%;
  }
`

export const InputContainer = styled.div`
  width: 33%;
  display: flex;
  justify-content: flex-end;

  .input-wrapper {
    width: auto;
    flex-grow: 0;
    padding-left: 20px !important;
  }
`
